import { render, staticRenderFns } from "./postscript.vue?vue&type=template&id=cd309360&scoped=true"
import script from "./postscript.vue?vue&type=script&lang=js"
export * from "./postscript.vue?vue&type=script&lang=js"
import style0 from "./postscript.vue?vue&type=style&index=0&id=cd309360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd309360",
  null
  
)

export default component.exports